import { createFileRoute } from '@tanstack/react-router'
import ContactRoyalty from 'Contact/components/Contact/Sections/ContactRoyalty'

export const Route = createFileRoute('/contact/$contactId/royalty')({
    component: ContactRoyalty,
})
